package com.devi3east.bashbuddy.dashboard.navigation

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.getValue
import androidx.navigation.NavGraphBuilder
import androidx.navigation.compose.composable
import bashbuddy.composeapp.generated.resources.Res
import bashbuddy.composeapp.generated.resources.sure_tip_ticket_info
import bashbuddy.composeapp.generated.resources.ticket_example
import com.devi3east.bashbuddy.auth.domain.models.UserType
import com.devi3east.bashbuddy.features.app.data.AppState
import com.devi3east.bashbuddy.features.app.data.Screen
import com.devi3east.bashbuddy.features.common.ui.components.Loader
import com.devi3east.bashbuddy.dashboard.ui.DashboardRoute
import com.devi3east.bashbuddy.dashboard.ui.InformationScreen

fun NavGraphBuilder.dashboardNavGraph(
    appState: AppState,
    navigateToEventDetail: (eventId: String, slug: String) -> Unit,
    navigateToTicketDetail: (ticketId: String) -> Unit,
    navigateToPrizeList: (eventId: String, slug: String) -> Unit
) {
    composable(Screen.DashboardScreen.route) {
        DashboardNavEntry(
            appState = appState,
            navigateToEventDetail = navigateToEventDetail,
            navigateToTicketDetail = navigateToTicketDetail,
            navigateToPrizeList = navigateToPrizeList
        )
    }
    composable(Screen.InformationScreen.route) {
        InformationNavEntry(appState = appState)
    }
}

@Composable
private fun DashboardNavEntry(
    appState: AppState,
    navigateToEventDetail: (String, String) -> Unit,
    navigateToTicketDetail: (String) -> Unit,
    navigateToPrizeList: (String, String) -> Unit
) {
    val uiState by appState.authViewModel.uiState.collectAsState()
    val profile = uiState.profile
    val organization = uiState.organization
    val token = uiState.token

    if (token.isNullOrBlank()) {
        LaunchedEffect(Unit) {
            appState.navController.navigate(Screen.SignInScreen.route) {
                popUpTo(0)
            }
        }
        return
    }

    if (profile == null) {
        Loader()
        return
    }

    LaunchedEffect(profile) {
        if (profile.userType == UserType.ORGANIZATION) {
            appState.authViewModel.loadOrganizationData(profile._id)
        }
    }

    DashboardRoute(
        appState = appState,
        profile = profile,
        organization = organization,
        navigateToEventDetail = navigateToEventDetail,
        navigateToTicketDetail = navigateToTicketDetail,
        navigateToPrizeList = navigateToPrizeList
    )
}

@Composable
private fun InformationNavEntry(
    appState: AppState
) {
    val images = listOf(
        Res.drawable.ticket_example,
        Res.drawable.sure_tip_ticket_info
    )

    InformationScreen(
        appState = appState,
        images = images,
        onBack = { appState.navController.popBackStack() }
    )
}